import { ToggleTabs as Tabs, assets } from '@round/whitelabel-ui';
import { useState } from 'react';
import PublicReportTikTokCampaign from '../../Campaigns/TiktokCampaign/PublicReportTiktokCampaigns';
import TikTokPlatformPosts from './TikTokPlatformPosts';
import { useTiktokCampaigns } from '../../Campaigns/TiktokCampaign/useTiktokCampaigns';
import { useCopyReportCampaignPostUrls } from 'Modules/Plans/Reports/Report/hooks/useCopyReportCampaignPostUrls';
import { PostUrlClipboardButton } from 'Modules/Plans/CopyToClipboard/PostUrlTable';
import styles from './TikTokTab.module.css';

const { RowVertical: RowVerticalIcon, TiktokSolid: TikTokSolidIcon } = assets;

type Props = {
    publicReportId: string | undefined;
};

const TikTokTab = ({ publicReportId }: Props) => {
    const [activeTab, setActiveTab] = useState<'campaigns' | 'posts'>('campaigns');
    const { campaigns, isCampaignsSuccess } = useTiktokCampaigns();
    const campaignIds = campaigns.map((campaign) => campaign.id);
    const areCampaignsInitialized = isCampaignsSuccess;
    const { isLoading: isCopyingPostUrls, copyReportCampaignPostUrls } = useCopyReportCampaignPostUrls(
        'tiktok',
        campaigns,
        publicReportId
    );

    return (
        <Tabs activeTab={activeTab} onChange={setActiveTab}>
            <div className={styles.header}>
                <Tabs.Menu>
                    <Tabs.Item name="campaigns" tooltip="View campaigns">
                        <RowVerticalIcon />
                    </Tabs.Item>
                    <Tabs.Item name="posts" tooltip="View posts" isDisabled={!areCampaignsInitialized}>
                        <TikTokSolidIcon />
                    </Tabs.Item>
                </Tabs.Menu>

                {activeTab === 'campaigns' && (
                    <PostUrlClipboardButton
                        className={styles.copyPostUrlsButton}
                        onClick={() => copyReportCampaignPostUrls()}
                        disabled={!campaigns.length}
                        isLoading={isCopyingPostUrls}
                    />
                )}
            </div>

            <Tabs.Panel name="campaigns">
                <PublicReportTikTokCampaign />
            </Tabs.Panel>

            <Tabs.Panel name="posts" className={styles.postsTab}>
                <TikTokPlatformPosts campaignIds={campaignIds} publicReportId={publicReportId} />
            </Tabs.Panel>
        </Tabs>
    );
};

export default TikTokTab;
